module.exports = __webpack_public_path__ + "img/2.9acd33f0.png";